import React from 'react'
import DetailCard from '../Main/DetailCard'

const value = {
  id: 1,
  heading: "Power Stacker",
  intro : [
    "Power Stacker is a comfortable and high secure fork-over leg electric stacker with high lifting height and free lifting, equipped with AC drive system. Standard equipped with 210/280Ah lead-acid sideway battery, metal cover. Chassis designed for life over 10 years.",
    "The optimized cushioning of the stand-on platform facilitates comfortable driving and greatly reduces back stress, even when driving over uneven surfaces."
  ],
  features: [
    "Three class speed while going down, more choices more efficiency.",
    "Better vision for operator with innovative design on relocating the third stage mast roller.",
    "Special design on cylinder, auto buffering to piston rods while falling. Better protect to pallet load.",
    "Size reduced cover plate, more sense of design, easier maintenance.",
    "Full steel cover protect from scrapes, reinforced safe assurance to core parts. No more need to worry about tiny daily damage on appearance and the resulting influence to internal systems.",
    "Laser cut all frame parts, high accuracy, neat and clean.",
    "Wider rider platform, good set- up spring shock absorber, more space of standing, more sense of comfortable, longer work life.",
    "The optimized cushioning of the stand-on platform facilitates comfortable driving and greatly reduces back stress, even when driving over uneven surfaces."
  ],
  imageUrl: "/images/power-stacker.png"
}

const PowerStacker = () => {
  return (
  <>
  <DetailCard lists={value} />
  </>
  )
}

export default PowerStacker